import { render, staticRenderFns } from "./link-edit-modal.vue?vue&type=template&id=5b48b110"
import script from "./link-edit-modal.vue?vue&type=script&lang=js"
export * from "./link-edit-modal.vue?vue&type=script&lang=js"
import style0 from "./link-edit-modal.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/content/link/link-edit-modal.vue
// module id = FcAF
// module chunks = 0